module.exports = __webpack_public_path__ + "static/media/daycon.adca80bd.png";